"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialSpecDetailEditViewModel = instanceOfMaterialSpecDetailEditViewModel;
exports.MaterialSpecDetailEditViewModelFromJSON = MaterialSpecDetailEditViewModelFromJSON;
exports.MaterialSpecDetailEditViewModelFromJSONTyped = MaterialSpecDetailEditViewModelFromJSONTyped;
exports.MaterialSpecDetailEditViewModelToJSON = MaterialSpecDetailEditViewModelToJSON;
exports.MaterialSpecDetailEditViewModelToJSONTyped = MaterialSpecDetailEditViewModelToJSONTyped;
/**
 * Check if a given object implements the MaterialSpecDetailEditViewModel interface.
 */
function instanceOfMaterialSpecDetailEditViewModel(value) {
    return true;
}
function MaterialSpecDetailEditViewModelFromJSON(json) {
    return MaterialSpecDetailEditViewModelFromJSONTyped(json, false);
}
function MaterialSpecDetailEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'msdSpecDetailNo': json['msdSpecDetailNo'] == null ? undefined : json['msdSpecDetailNo'],
        'msdOrgId': json['msdOrgId'] == null ? undefined : json['msdOrgId'],
        'msdMaterialNo': json['msdMaterialNo'] == null ? undefined : json['msdMaterialNo'],
        'msdSpec': json['msdSpec'] == null ? undefined : json['msdSpec'],
        'msdChestWidth': json['msdChestWidth'] == null ? undefined : json['msdChestWidth'],
        'msdClothesLength': json['msdClothesLength'] == null ? undefined : json['msdClothesLength'],
        'msdSizeWidth': json['msdSizeWidth'] == null ? undefined : json['msdSizeWidth'],
        'msdSizeLength': json['msdSizeLength'] == null ? undefined : json['msdSizeLength'],
        'msdSizeUnit': json['msdSizeUnit'] == null ? undefined : json['msdSizeUnit'],
        'sizeUnit': json['sizeUnit'] == null ? undefined : json['sizeUnit'],
        'mcMaterialNo': json['mcMaterialNo'] == null ? undefined : json['mcMaterialNo'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'msSpec': json['msSpec'] == null ? undefined : json['msSpec'],
        'pssSpecificationName': json['pssSpecificationName'] == null ? undefined : json['pssSpecificationName'],
    };
}
function MaterialSpecDetailEditViewModelToJSON(json) {
    return MaterialSpecDetailEditViewModelToJSONTyped(json, false);
}
function MaterialSpecDetailEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'msdSpecDetailNo': value['msdSpecDetailNo'],
        'msdOrgId': value['msdOrgId'],
        'msdMaterialNo': value['msdMaterialNo'],
        'msdSpec': value['msdSpec'],
        'msdChestWidth': value['msdChestWidth'],
        'msdClothesLength': value['msdClothesLength'],
        'msdSizeWidth': value['msdSizeWidth'],
        'msdSizeLength': value['msdSizeLength'],
        'msdSizeUnit': value['msdSizeUnit'],
        'sizeUnit': value['sizeUnit'],
        'mcMaterialNo': value['mcMaterialNo'],
        'mdProduct': value['mdProduct'],
        'msSpec': value['msSpec'],
        'pssSpecificationName': value['pssSpecificationName'],
    };
}
